<template>
    <v-dialog
        v-bind:value="value"
        :max-width="width"
        :persistent="persistent"
        @input="$emit('input', $event)"
        @click:outside="$emit('click:outside')"
        :fullscreen="fullscreen"
        :transition="transition"
        :scrollable="scrollable"
    >
        <v-card
            :style="{'min-width': minWidth}"
            :class="{'stickyFooter': stickyFooter}">
            <v-card-title class="text-h6"
                          :class="{fullscreenTitle: fullscreen, scroll: scrolledToTop, 'pl-14': fullscreen, 'py-3':fullscreen}">
                <v-btn v-if="fullscreen" style="position:absolute; left: 10px;"
                       icon dark @click="$emit('cancel')"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <span :style="{'font-size': fullscreen ? '0.90em' : '1em'}">{{ title }}</span>
            </v-card-title>
            <v-card-text v-scroll.self="onScroll" ref="scrollable" :class="{'pt-4': fullscreen}">
                <slot></slot>
            </v-card-text>
            <v-card-actions :class="scrolledToBottom ? 'scroll' : ''">
                <div v-if="!hideButtons" class="d-flex">
                    <v-spacer v-if="!replaceButtons"></v-spacer>
                    <slot name="button"></slot>
                    <div v-if="!replaceButtons">
                        <Button v-if="!hideCancelButton" :text="true" @click="$emit('cancel')" :color="ada.darkGrey">
                            {{ cancelText }}
                        </Button>
                        <Button :text="true" :disabled="okDisabled" @click="$emit('ok')" :color="ada.pink"
                                v-bind:loading="loading">
                            {{ okText }}
                        </Button>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Button from "./buttons/Button";
import ada from "../scss/ada_colors.scss"

export default {
    name: "Dialog",
    components: {Button},
    props: {
        value: {},
        width: {
            type: String,
            default: '450'
        },
        title: {
            type: String,
            default: 'Ad Control'
        },
        okDisabled: {
            type: Boolean,
            default: false
        },
        okText: {type: String, default: 'Speichern'},
        cancelText: {type: String, default: 'Abbrechen'},
        loading: Boolean,
        persistent: {type: Boolean, default: false},
        hideButtons: {
            type: Boolean,
            default: false
        },
        replaceButtons: {
            type: Boolean,
            default: false
        },
        stickyFooter: {
            type: Boolean,
            default: false
        },
        fullscreen: {
            type: Boolean,
            default: false
        },
        scrollable: {
            type: Boolean,
            default: false
        },
        scrollTrigger: {}, //if this changes trigger this.onScroll
        transition: {
            type: String,
            default: 'scale-transition'
        },
        minWidth: {
            type: String,
            default: '450px'
        },
        hideCancelButton: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            scrolledToBottom: false,
            scrolledToTop: false,
            listening: false,
            ada
        }
    },
    mounted() {
        this.onScroll();
        setTimeout(() => {
            this.onScroll();
        }, 500)
        if (this.fullscreen) document.getElementsByTagName('html')[0].classList.add('hideScroll');
    },
    destroyed() {
        if (this.fullscreen) document.getElementsByTagName('html')[0].classList.remove('hideScroll')
    },
    computed: {
        errorCount() {
            return this.$store.state.errorCount;
        },
    },
    methods: {
        onScroll(el) {
            let element = el ? el.currentTarget : this.$refs.scrollable;
            if (element && element.scrollHeight > element.clientHeight) {
                this.scrolledToBottom = element.scrollHeight !== (element.clientHeight + element.scrollTop);
                this.scrolledToTop = element.scrollTop !== 0;
            }
        }
    },
    watch: {
        errorCount() {
            //this.loading = false;
            this.$emit('update:loading', false);
        },
        scrollTrigger() {
            setTimeout(() => {
                this.onScroll();
            }, 500)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .stickyFooter .v-card__actions {
    position: sticky;
    bottom: 0;
    background: #fff !important;
    width: 100%;
    z-index: 10;
}


::v-deep .v-dialog.v-dialog--fullscreen {
    left: auto;
    right: 0 !important;
    width: calc(100% - 256px) !important;
}

.fullscreenTitle {
    color: white;
    background: linear-gradient(90deg, #da2567 0%, #b92972 50%, #752b77 100%);;
    background: linear-gradient(90deg, $ada_pink 0%, $ada_purple 75%, $ada_blue 100%);;
}

.scroll {
    box-shadow: 1px 2px 18px rgb(0 0 0 / 35%);
    z-index: 1000;
}
</style>